import { Track } from '../../classes/track'

export function tracksToM3u8(tracks: Track[]): string {
  let m3u: string = `#EXTM3U\n\n`

  for (const track of tracks) {
    m3u += `#EXTINF:${track.durationSeconds || -1},${track.artist} - ${track.title}\n`

    let location: string = track.location

    if (location.includes(':/')) { // If windows then convert to backslash and \r\n
      location = location.replace(/\//g, '\\')
      location = location.replace(/\\n/g, '\\r\\n')
    }

    m3u += `${location}\n\n`
  }

  return m3u
}
